var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.getList, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { width: "50", prop: "id", label: "ID" },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "rightsCode",
              label: "权益编号",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "overflow-ellipsis",
                        attrs: { slot: "reference" },
                        slot: "reference",
                      },
                      [_vm._v(_vm._s(scope.row.rightsCode))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "rightsName",
              label: "权益名称",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "overflow-ellipsis",
                        attrs: { slot: "reference" },
                        slot: "reference",
                      },
                      [_vm._v(_vm._s(scope.row.rightsName))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "clientTypes", label: "客户端类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.clientTypes.split(","),
                    function (item) {
                      return _c(
                        "el-tag",
                        {
                          key: item,
                          staticStyle: {
                            "margin-right": "5px",
                            "margin-bottom": "5px",
                          },
                          attrs: { size: "small" },
                        },
                        [_vm._v(_vm._s(item))]
                      )
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "description",
              label: "描述文案",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    !scope.row.description
                      ? _c("span", [_vm._v("暂无描述")])
                      : _c(
                          "span",
                          {
                            staticClass: "overflow-ellipsis",
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [_vm._v(_vm._s(scope.row.description))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "limitParams", label: "限制参数" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(
                    scope.row.limitParams.split(","),
                    function (item) {
                      return _c(
                        "el-tag",
                        {
                          key: item,
                          staticStyle: {
                            "margin-right": "5px",
                            "margin-bottom": "5px",
                          },
                          attrs: { size: "small" },
                        },
                        [_vm._v(_vm._s(item))]
                      )
                    }
                  )
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "80", prop: "state", label: "生效状态" },
          }),
          _vm.getCurrentTab === "localData"
            ? _c("el-table-column", {
                attrs: { width: "80", prop: "reviewStatus", label: "审核状态" },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              width: "120",
              prop: "remark",
              label: "备注",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    !scope.row.remark
                      ? _c("span", [_vm._v("暂无备注")])
                      : _c(
                          "span",
                          {
                            staticClass: "overflow-ellipsis",
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [_vm._v(_vm._s(scope.row.remark))]
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm.getCurrentTab === "localData"
            ? _c("el-table-column", {
                attrs: { fixed: "right", label: "操作" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "MEMBER_RIGHTS_MANAGE_LOG",
                                  expression: "'MEMBER_RIGHTS_MANAGE_LOG'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.checkLog(scope.row.id)
                                },
                              },
                            },
                            [_vm._v("查看日志")]
                          ),
                          scope.row.reviewStatus !== "待审核"
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "MEMBER_RIGHTS_MANAGE_EDIT",
                                      expression: "'MEMBER_RIGHTS_MANAGE_EDIT'",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              )
                            : _vm._e(),
                          scope.row.reviewStatus === "待审核"
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "MEMBER_RIGHTS_MANAGE_AUDIT",
                                      expression:
                                        "'MEMBER_RIGHTS_MANAGE_AUDIT'",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAudit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("审核")]
                              )
                            : _vm._e(),
                          scope.row.reviewStatus === "草稿"
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "MEMBER_RIGHTS_MANAGE_FOR_AUDIT",
                                      expression:
                                        "'MEMBER_RIGHTS_MANAGE_FOR_AUDIT'",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSubmitAudit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("提交审核")]
                              )
                            : _vm._e(),
                          scope.row.reviewStatus === "待审核"
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value:
                                        "MEMBER_RIGHTS_MANAGE_CANCEL_AUDIT",
                                      expression:
                                        "'MEMBER_RIGHTS_MANAGE_CANCEL_AUDIT'",
                                    },
                                  ],
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleCancelAudit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("撤销审核")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "MEMBER_RIGHTS_MANAGE_DEL",
                                  expression: "'MEMBER_RIGHTS_MANAGE_DEL'",
                                },
                              ],
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handelDel(scope.row.id)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1188568594
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("AddDialog", {
        attrs: {
          addDialog: _vm.editDialog,
          title: "编辑会员权益",
          addFrom: _vm.addFrom,
        },
        on: {
          "update:addDialog": function ($event) {
            _vm.editDialog = $event
          },
          "update:add-dialog": function ($event) {
            _vm.editDialog = $event
          },
          updateData: _vm.updateData,
        },
      }),
      _c("logDialog", {
        attrs: { logDialog: _vm.logDialog, id: _vm.logId },
        on: {
          "update:logDialog": function ($event) {
            _vm.logDialog = $event
          },
          "update:log-dialog": function ($event) {
            _vm.logDialog = $event
          },
          "update:id": function ($event) {
            _vm.logId = $event
          },
        },
      }),
      _c("AuditDialog", {
        attrs: {
          auditDialog: _vm.auditDialog,
          afterUpdate: _vm.afterUpdate,
          beforeUpdate: _vm.beforeUpdate,
          showAuditOpinion: _vm.showAuditOpinion,
        },
        on: {
          "update:auditDialog": function ($event) {
            _vm.auditDialog = $event
          },
          "update:audit-dialog": function ($event) {
            _vm.auditDialog = $event
          },
          "update:afterUpdate": function ($event) {
            _vm.afterUpdate = $event
          },
          "update:after-update": function ($event) {
            _vm.afterUpdate = $event
          },
          "update:beforeUpdate": function ($event) {
            _vm.beforeUpdate = $event
          },
          "update:before-update": function ($event) {
            _vm.beforeUpdate = $event
          },
          "update:showAuditOpinion": function ($event) {
            _vm.showAuditOpinion = $event
          },
          "update:show-audit-opinion": function ($event) {
            _vm.showAuditOpinion = $event
          },
          updateData: _vm.updateData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }